module.exports = __webpack_public_path__ + "static/media/blockc.3c7b6a6b.svg";